import { State, PracticeInfo, AppointmentTypesState } from 'types';
import { createSelector } from 'reselect';

type GetPracticeProps = {
  practiceId: number | string;
};

const _getPractice = (state: State, { practiceId }: GetPracticeProps): PracticeInfo =>
  state.entities.practices ? state.entities.practices[practiceId] : undefined;

export const getPractice = createSelector(
  _getPractice,
  (state: State) => state.entities.appointmentTypes,
  (practice: PracticeInfo, appointmentTypes: AppointmentTypesState): PracticeInfo => {
    if (!practice) {
      return undefined;
    }
    if (appointmentTypes && practice.appointmentTypes) {
      return {
        ...practice,
        appointmentTypes: practice.appointmentTypes
          .filter(
            (appointmentTypeId) =>
              appointmentTypes[appointmentTypeId] &&
              appointmentTypes[appointmentTypeId].patientBookable,
          )
          .sort((a, b) => appointmentTypes[a].sequence - appointmentTypes[b].sequence),
      };
    }
    return practice;
  },
);
